export function isExternalUrl(href: string, siteUrl: string): boolean {
  if (!href || /^(#|mailto:|tel:|javascript:)/.test(href)) return false
  if (/^(https?:)?\/\//.test(href)) return !href.startsWith(siteUrl)
  if (href.startsWith('/')) {
    const sitePath = siteUrl.replace(/^https?:\/\/[^/]+/, '').replace(/\/$/, '')
    return sitePath !== '' && !href.startsWith(sitePath + '/') && href !== sitePath
  }
  return false
}

export function externalLinkProps(href: string | undefined, siteUrl: string) {
  if (!href || !isExternalUrl(href, siteUrl)) return {}
  return { target: '_blank' as const }
}
